<template>
  <path
    d="M15 19.0002H4.83002C4.04002 19.0002 3.56002 18.1202 3.99002 17.4602L7.50002 12.0002L3.99002 6.54018C3.56002 5.88018 4.04002 5.00018 4.83002 5.00018H15C15.65 5.00018 16.26 5.31018 16.63 5.84018L20.59 11.4202C20.84 11.7702 20.84 12.2302 20.59 12.5802L16.63 18.1602C16.26 18.6802 15.65 19.0002 15 19.0002ZM6.50002 17.0002H15L18.5 12.0002L15 7.00018H6.50002L10 12.0002L6.50002 17.0002Z"
  />
</template>
